import BlogDetails from "../../../components/blogs/BlogDetails";
import PageTitle2 from "../../../components/blogs/PageTitle2";
import Footer1 from "../../../components/footer/Footer1";
import Header1 from "../../../components/headers/Header1";
import { allBlogs } from "../../../data/blogs";
import React from "react";
import { useParams } from "react-router-dom";

import MetaComponent from "../../../components/common/MetaComponent";



export default function BlogDetailsPage() {
  let params = useParams();
  const blogItem =
    allBlogs.filter((elm) => elm.id == params.id)[0] || allBlogs[0];

  const defaultTitle = blogItem?.Title || blogItem?.title || "Blog Details | AskMeRealty";
  const defaultDescription =
    blogItem?.ShortDescription ||
    blogItem?.shortDescription ||
    "Read the latest property insights and updates on AskMeRealty.";
  const defaultKeywords =
    blogItem?.MetaKeywords ||
    [blogItem?.CategoryName || blogItem?.Category || "Blog", "AskMeRealty"].join(", ");

  const [title, setTitle] = React.useState(defaultTitle);
  const [description, setDescription] = React.useState(defaultDescription);
  const [keywords, setKeywords] = React.useState(defaultKeywords);
    const [MetaImage, setMetaImage] = React.useState("");

  const metadata = {
    title: title,
    description: description,
    keywords: keywords,
    url: window.location.href,
    siteName: "AskMeRealty",
    canonical: window.location.href,
    image: MetaImage,
  };


  return (
    <>
      <MetaComponent meta={metadata} />
      <Header1 />
      <PageTitle2 />
      <BlogDetails blogItem={blogItem} setTitle={setTitle} setDescription={setDescription} setKeywords={setKeywords} setMetaImage={setMetaImage} />
      <Footer1 />
    </>
  );
}
